import { createSelector } from '@reduxjs/toolkit';

import { formatLengthToArchitecturalString, formatLengthToFeetInchesSixteenthsString } from '@paragon/client-tools';
import { DistanceFormat } from '@paragon/contract-library';
import { assertExhaustiveSwitch } from '@paragon/utilities';

import { RootState } from '../store';

const distanceFormatter = (distanceFormat: DistanceFormat) => {
  switch (distanceFormat) {
    case 'FeetInchesSixteenths':
      return formatLengthToFeetInchesSixteenthsString;
    case 'Architectural':
      return formatLengthToArchitecturalString;
    default:
      assertExhaustiveSwitch(distanceFormat);
  }
};

export const getDistanceFormatterSelector = createSelector(
  (state: RootState) => state.application.distanceFormat,
  distanceFormatter,
);
